import type { PartnerConfig } from "@/content/partners/types"

export const PARCELAR_PARTNER_SLUG = "parcelar"

export const PARCELAR_LOGO_PATH = "/partners/parcelar/logo.png"

export const parcelarBrand = {
  accent: "#71883C",
  accentDark: "#54672C",
  accentLight: "#A3BA76",
  navy: "#21404F",
  ringFrom: "#71883C",
  ringTo: "#21404F",
  benefit: "#4ade80",
  benefitForeground: "#002a50",
} as const

export const parcelarPartnerConfig: PartnerConfig = {
  slug: PARCELAR_PARTNER_SLUG,
  name: "Parcelar",
  fullName: "Parcelar Urbanismo",
  logoPath: PARCELAR_LOGO_PATH,
  benefitMode: "percent_increment",
  benefitPercentIncrement: 2,
  isActive: true,
  metadata: {
    website: "https://parcelarurbanismo.com.br/",
    industry: "urbanismo",
  },
}

export const parcelarPartnerContent = {
  ...parcelarPartnerConfig,
  tagline: "Loteamentos e urbanismo com qualidade e infraestrutura completa",
  websiteUrl: "https://parcelarurbanismo.com.br/",
  benefitHeadline: "Benefício para colaboradores",
  heroHeadline: "Colaboradores da Parcelar Urbanismo têm desconto extra na energia",
  heroSubtitle: "Economize até 27% do total da sua conta de luz com a energia solar por assinatura da Astra.",
  partnershipIntro:
    "Colaboradores da Parcelar Urbanismo têm desconto extra na energia por assinatura, com cadastro simples e benefício automático.",
  partnershipTitle: "Parcelar Urbanismo e energia limpa, juntos",
} as const
